import {ReactNode, useContext} from "react";
import {poll} from "../../../../admin/spinup/utilities";
import {StoreContext} from "../../../../../stores/StoreLoader";
import {useMachine} from "@xstate/react";
import {FetchMachine} from "../../../../machines/FetchMachine";

type FetchMachineState = "IDLE" | "PENDING" | "SUCCESS" | "FAILURE"

export function ForceRefreshSourceButton(props: {
    sourceId: number,
    renderButton: (state: FetchMachineState) => ReactNode,
    callback: () => void,
    [restProps: string]: any
}) {
    const {organizationStore} = useContext(StoreContext);
    const {sourceId, renderButton, callback, ...restProps} = props;
    const [current, send] = useMachine(FetchMachine);

    const handleRefresh = async () => {
        send("FETCH");
        await organizationStore.refreshContentSource(sourceId);
        await poll(
            () => organizationStore.pollSource(sourceId),
            () => {
            },
            () => {
                send("FULFILL");
                callback();
            },
            () => send("REJECT"),
        );
    }

    return <button disabled={current.value !== "IDLE"} onClick={handleRefresh} {...restProps}>
        {renderButton(current.value as FetchMachineState)}
    </button>;
}